import { useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useUserArrayParam } from "../../utils/hooks";
import React, { useEffect, useState } from "react";
import { Divider, ListItemText, MenuItem } from "@material-ui/core";
import MuiTextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { simpleParamsFormActionCreator } from "../Settings/forms/simpleParamsFormActionCreator";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from 'uuid';

const TextField = withStyles((theme) => ({
  root: {
    "& .MuiSelect-root, & .MuiInputBase-root input": {
      paddingTop: 10.5,
      paddingBottom: 10.5,
    },

    "& .MuiSelect-root": {
      display: 'flex',
      alignItems: 'center',
      '& .MuiListItemText-root, & > span' : {
        margin: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
    },

    "&.MuiTextField-root label": {
      top: 0,
      '&[data-shrink="false"]' : {
        textOverflow: 'ellipsis',
        right: 36,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }
    },
    
    "&.MuiTextField-root label[data-shrink='true']": {
      top: 0
    },
    
  }
}))(MuiTextField);

export default function CustomSelectTextField({
  type = "", 
  name, 
  control,
  actionTitle,
  action,
  defaultItems,
  ...props
}) {
  
  const {t} = useTranslation()
  const dispatch = useDispatch()

  // Build an initial value list if provided (array of strings or objects)
  const initialList = React.useMemo(() => {
    if (!defaultItems || !Array.isArray(defaultItems)) return undefined;
    return defaultItems.map((it) => {
      if (typeof it === 'string') return { id: uuidv4(), name: it };
      if (it && typeof it === 'object') return { id: it.id || uuidv4(), name: it.name || '' };
      return null;
    }).filter(Boolean);
  }, [Array.isArray(defaultItems) ? defaultItems.map((v) => (typeof v === 'string' ? v : v?.name || '')).join('|') : '']);

  const [params] = useUserArrayParam(type, initialList)
  const {
    field: { onChange, value },
    fieldState: { invalid, isTouched, isDirty, error},
    formState: { touchedFields, dirtyFields}
  } = useController({
    name,
    control,
    defaultValue: "",
  });



  const [inputValue, setInputValue] = useState('')
  
  const handleAction = React.useCallback(() => {
    //display an alert with 
    dispatch(simpleParamsFormActionCreator({title: actionTitle || t("interface.Edit") + " " + props.label, type: type}))
  }, [])

  const handleChange = (e) => {
    if(e.target.value ==='add_item')
      (action  || handleAction)()
    else
      onChange(e.target.value)
  }

  return (
    <TextField 
      select 
      {...props}
      onChange={handleChange} 
      value={value}
      SelectProps={{
        MenuProps: {
          TransitionProps: {
            mountOnEnter: true,
            unmountOnExit: true,
          }
        }
      }}
    >
        <MenuItem value="" style={{color: 'transparent'}}>
          None
        </MenuItem>
        {
          params.map(param => <MenuItem key={param.id} value={param.name}>{param.name}</MenuItem>)
        }
        <Divider />
        <MenuItem value="add_item">{actionTitle || t('common:interface.add')}</MenuItem>
    </TextField>
  );
}
